import { useContext } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import loginPage from './pages/Login/Login'
import Main from './pages/Main/Main'
import recoverpass from './pages/Login/passRecovery'
import Chamgepass from './pages/Login/passChange'
import Monitoramento from './pages/Monitoramento'
import WhatsBot from './pages/WhatsBot'
import Dashboard from './pages/Dashboard'
import Chamados from './pages/Chamados'
import Backups from './pages/Backups'
import CadastroEmpresas from './pages/Backups/Cadastro'
import ReportSemanalEmpresas from './pages/Backups/DashboardEmpresas'
import ReportSemanal from './pages/Backups/ReportSemana'
import ReportSemanalAll from './pages/Backups/AllReportSemanal'
import ReportSemanalAvulso from './pages/Backups/AllReportSemanalAvulso'
import MostraEmpresa from './pages/Backups/MostraEmpresa'
import MostraScript from './pages/Backups/CadScript'
import ChamadoUnico from './pages/Chamados/ChamadoUnico'
import GestaoEmpresas from './pages/GestaoEmpresas'
import GestaoEmpresasEdit from './pages/GestaoEmpresas/EditEmpresa'
import Notificacoes from './pages/Notificacoes'
import Users from './pages/Users'
import Gestao from './pages/Gestao'

import { Context } from './context/AuthContext'

function CustomRoute({ isPrivate, ...rest }) {
  const { loading, authenticated } = useContext(Context)
  if (loading) {
    return <h1>Loading...</h1>
  }
  if (isPrivate && !authenticated) {
    return <Redirect exact to="/login" />
  }

  return <Route {...rest} />
}

export default function Routes() {
  return (
    <Switch>
      <CustomRoute exact path="/login" component={loginPage} />
      <CustomRoute exact path="/Gestao" component={Gestao} />

      <CustomRoute exact path="/recuperarsenha" component={recoverpass} />
      <CustomRoute exact path="/trocar_senha" component={Chamgepass} />
      <CustomRoute isPrivate exact path="/" component={Main} />
      <CustomRoute isPrivate exact path="/Main" component={Main} />
      <CustomRoute isPrivate exact path="/Users" component={Users} />
      <CustomRoute
        isPrivate
        exact
        path="/Notificacoes"
        component={Notificacoes}
      />

      <CustomRoute
        isPrivate
        exact
        path="/Gestao/empresas"
        component={GestaoEmpresas}
      />
      <CustomRoute
        isPrivate
        exact
        path="/Gestao/empresas/edit"
        component={GestaoEmpresasEdit}
      />

      <CustomRoute
        isPrivate
        exact
        path="/cad/empresas"
        component={CadastroEmpresas}
      />
      <CustomRoute
        isPrivate
        exact
        path="/cad/empresas/Show"
        component={MostraEmpresa}
      />
      <CustomRoute
        isPrivate
        exact
        path="/cad/empresas/script"
        component={MostraScript}
      />

      <CustomRoute
        isPrivate
        exact
        path="/reportsemanal/empresas"
        component={ReportSemanalEmpresas}
      />
      <CustomRoute
        isPrivate
        exact
        path="/reportsemanal"
        component={ReportSemanal}
      />
      <CustomRoute
        isPrivate
        exact
        path="/reportsemanal/avulsos"
        component={ReportSemanalAvulso}
      />
      <CustomRoute
        isPrivate
        exact
        path="/reportsemanal/all"
        component={ReportSemanalAll}
      />
      <CustomRoute isPrivate exact path="/Dashboard" component={Main} />
      <CustomRoute
        isPrivate
        exact
        path="/Monitoramento"
        component={Dashboard}
      />
      <CustomRoute isPrivate exact path="/Backups" component={Backups} />
      <CustomRoute isPrivate exact path="/WhatsBot" component={WhatsBot} />
      <CustomRoute isPrivate exact path="/Mon" component={Monitoramento} />
      <CustomRoute isPrivate exact path="/Chamados" component={Chamados} />
      <CustomRoute
        isPrivate
        exact
        path="/Chamados/unico"
        component={ChamadoUnico}
      />
    </Switch>
  )
}
